import type { ApiConfig } from '../../types'

export const withdrawalHistoryApiConfig = {
  existSubType: false,
  fetchableRange: undefined,
  limit: 1000,
  order: 'desc',
  range: 1000 * 60 * 60 * 24 * 90, // 90 days
  requestDelay: 500, // レートリミット対策 (SAPI)
  requiresRange: true,
  type: 'withdrawal-history',
} as const satisfies ApiConfig
